import _ from 'lodash';
import { REDIRECT_MEMBER, SHOW_COMMEMORATE, SHOW_RIBBON } from 'src/constants';
import styled from 'styled-components';
import ButtonSubscribe from './button-subscribe';
const WidgetSubscribe = ({ className = '', onClick }) => {
  return (
    <>
      <WidgetWrapper className={`button-subscribe ${className}`} onClick={onClick}>
        {!_.isEmpty(REDIRECT_MEMBER) && <ButtonSubscribe refKey='subscribe' className='--blue' text='SUBSCRIBE' redirectUrl={REDIRECT_MEMBER} />}
        <ButtonSubscribe refKey='login' text='Login' />
      </WidgetWrapper>
    </>
  );
};

export default WidgetSubscribe;

const WidgetWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 15px;
  &.--mobile {
    display: block;
    gap: 10px;

    .button-subscribe {
      margin: 5px 0;
      padding: 5px 10px;
      width: 100px;
      justify-content: flex-end;
      /* font-weight: 400;
    font-size: 10px; */
    }
  }
`;
